import { DirectoEventResponse } from '../../../../../api/models/directo-event-response'
import { DirectoEvent } from './types'
import { DirectoFormValues } from './schema'
import { DirectoEventCreate, DirectoEventUpdate } from './request'

export function toDirectoEventCreate(transitOperationId: number, formValues: DirectoFormValues): DirectoEventCreate {
  return {
    transitOperationId,
    customerId: formValues.customerId,
    descriptionAddendum: formValues.descriptionAddendum,
  }
}

export function toDirectoEventUpdate(transitOperationId: number, formValues: DirectoFormValues): DirectoEventUpdate {
  return {
    transitOperationId,
    customerId: formValues.customerId,
    descriptionAddendum: formValues.descriptionAddendum,
  }
}
export function toDirectoFormValues(directoEvent: DirectoEvent): DirectoFormValues {
  return {
    id: directoEvent.id,
    customerId: directoEvent.customerId,
    status: directoEvent.status,
    descriptionAddendum: directoEvent.descriptionAddendum,
  }
}

export function fromDirectoEventResponse(response: DirectoEventResponse): DirectoEvent {
  return {
    id: response.id,
    customerId: response.customerId,
    status: response.status,
    descriptionAddendum: response.descriptionAddendum ?? '',
    remoteStaffCode: response.remoteStaffCode ?? '',
  }
}

